// extracted by mini-css-extract-plugin
export default {"wrapper":"Popover_wrapper__hbqHv"};